// A new or changed account number must be typed twice and match: a slip sends salary to the wrong
// person. An account number left as it is stored needs no retyping (a person updating only the UPI
// address should not have to re-enter it).
export function accountNeedsConfirm(account, storedAccount) {
  return String(account ?? "").trim() !== String(storedAccount ?? "").trim();
}

export function accountConfirmed(form, storedAccount) {
  if (!accountNeedsConfirm(form.account, storedAccount)) return true;
  return form.confirm === form.account;
}

// The tick box before saving: unticked by default; the server refuses a save without it.
export const BANK_DETAILS_CONFIRMATION =
  "I have checked these bank details. If they are wrong, I am responsible for any payment made to them.";
